import { FeedbackType } from '@weave/schema-gen-ts/dist/schemas/office-assistant/v1/office_assistant_service.pb';
import { TagSelectionHooks } from '@frontend/tag-selection';

export const SMART_TAG_FEEDBACK_THRESHOLDS: Parameters<
  typeof TagSelectionHooks.useTagFeedbackFlow
>[0]['feedbackClickThreshold'] = {
  [FeedbackType.FEEDBACK_TYPE_BAD]: 3,
  [FeedbackType.FEEDBACK_TYPE_GOOD]: -1,
};
